import { render, staticRenderFns } from "./MapCard.vue?vue&type=template&id=023c5233&scoped=true"
import script from "./MapCard.vue?vue&type=script&lang=js"
export * from "./MapCard.vue?vue&type=script&lang=js"
import style0 from "./MapCard.vue?vue&type=style&index=0&id=023c5233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c5233",
  null
  
)

export default component.exports